export default __webpack_public_path__ + "static/nowaeres-fb218dad516283ba6b763460ec7b7a1a.png";